import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState, } from 'react';
import { Config } from '../config';
const configContext = createContext({});
function ConfigProvider({ config, children, }) {
    const [loading, setLoading] = useState(true);
    const getData = () => {
        setLoading(true);
        fetch(`${window.location.origin}/settings.json`)
            .then(function (res) {
            return res.json();
        })
            .then(function (data) {
            if (data) {
                Config.authApi = data.authApi;
                Config.graphQlApi = data.graphQlApi;
                Config.themeUrl = data.themeUrl;
            }
            setLoading(false);
        })
            .catch(function (err) {
            console.log(err, ' error');
            setLoading(false);
        });
    };
    useEffect(() => {
        if (config.authApi) {
            Config.authApi = config.authApi;
            Config.graphQlApi = config.graphQlApi;
            Config.themeUrl = config.themeUrl;
            setLoading(false);
        }
        else {
            getData();
        }
    }, []);
    const memoedValue = useMemo(() => ({
        loading,
    }), [loading]);
    return (_jsx(configContext.Provider, Object.assign({ value: memoedValue }, { children: !loading && children })));
}
export { ConfigProvider, configContext };
export function useConfig() {
    return useContext(configContext);
}
//# sourceMappingURL=useConfig.js.map